const toggleBtn = document.getElementById('btn_caract');
const caractList = document.getElementById('target_caract');
const formProduct = document.getElementById('product-form');
const addBtn = document.getElementById('add-to-cart-btn');

const qtyInput = document.querySelectorAll('.quantity-input');
const btnIncrease = document.querySelectorAll('.qty-increase');
const btnDecrease = document.querySelectorAll('.qty-decrease');
const btnModeles = document.querySelectorAll('.variant-button');
const priceTag = document.querySelectorAll('.price-value');
const btnCart = document.getElementById('add-to-cart-btn');
const variantSticky = document.getElementById('dynamic-variant');
const cartSticky = document.getElementById('target-sticky-cart');

const allBundles = document.querySelectorAll('.bundle-variant-list');
const priceBundle = document.querySelectorAll('.price-bundle');

const idProductVariant = document.getElementById('product_variants_list')
const idProductVariantSticky = document.getElementById('variant_sticky')

const stickyTarget = document.getElementById('sticky-cart-target')
const containerPaiement = document.getElementById('container-cart-paiement-product')

const priceTotal = document.querySelectorAll('.price-total')
const priceDiscount = document.querySelectorAll(".price-value-discount");
const percentDiscount = document.querySelectorAll('.percent-discount');
const btnReadMore = document.querySelector('.read-more-btn')
const textReadDesc = document.querySelector('.txt-desc')

const animBlockBanner = document.getElementById('block_banner_description_product')
const listDescProduct = document.querySelectorAll('.block-text-desc-product-side')
const blockImgLong = document.getElementById('img_long_product')
const allTitleOdd = document.querySelectorAll('.title-side-item-odd-even');
const allImgOdd = document.querySelectorAll('.img-side-odd-even')

const btnCallCart = document.querySelectorAll('.target-call-cart')
const btnCallCartBundle = document.querySelectorAll('.target-call-cart-bundle')
const loaderPaiement = document.querySelectorAll('.loader')
const upsellTarget = document.getElementById('block-upsell-product')
const modalSuccessAdd = document.getElementById('sticky-add-product-modal');
const overlaySuccess = document.getElementById('overlay-page')
const lottieContainer = document.getElementById('lottie-container')
const targetCloseSuccess = document.getElementById('target-close-success')

const btnSuccessCart = document.querySelector('.target-success-cart')
const btnSuccessBuy = document.querySelector('.target-success-buy')
const modalSuccessNext = document.getElementById('upsell-modal');
const btnNextSuccess = document.getElementById('cta-next-success')
const targetCartPageProduct = document.getElementById('cart-side-modal')
const listUpsell = document.getElementById('list-upsell')

const lazyLoader = document.querySelectorAll('.lazy-loader')

const getShopifyOptions = window.shopifyOptions;
const getShopifyMultiOptions = window.shopifyMultiSourcingOptions;

const baseApiProduct = "https://appgeniux.fr";
const shopNameProduct = 'shop1'
const collectionDiscount = productInfo?.collections;
const handleProductCurrent = productInfo?.handle;
const upsellProduct = productInfo?.upsell;
const limitShowOptionList = 4;
const secondeWaitDiscount = 5000;

/** {nameBundle:{options:["val","val"],state:{...}}} */
const bundlesState = {};
const variantsByOption = {};
const allVariants = [];
let countProduct = 1;
let priceCurrent = 0;
let stateNextSuccess = ""


const initDOMAction = {
    submitBuyProduct: () => {
        function showPaymentModal() {
            alert('Produit ajouté ! Veux-tu passer à la caisse ?');
        }
        formProduct && formProduct.addEventListener('submit', function (e) {
            e.preventDefault();
            const formData = new FormData(formProduct);
            fetch('/cart/add.js', {
                method: 'POST',
                body: formData,
                headers: {
                    Accept: 'application/json',
                },
            })
                .then((response) => {
                    if (!response.ok) throw new Error('Erreur ajout au panier');
                    return response.json();
                })
                .then((data) => {

                    // Ici, tu peux déclencher ton modal personnalisé pour proposer le paiement
                    showPaymentModal(); // Ta fonction modal à créer
                })
                .catch((err) => {
                    alert("Erreur lors de l'ajout au panier");

                });
        });
    },
    domCaracteristique: () => {
        if (toggleBtn && caractList) {
            toggleBtn.addEventListener('click', function () {
                target_caract.classList.toggle('active');
                const span = this.querySelector('span');
                if (!caractList.classList.contains('active')) {
                    span.textContent = '+';
                } else {
                    span.textContent = '−';
                }
            });
        }
    },
    domSwitchModels: () => {
        /** TOP */
        btnIncrease.forEach(e => {
            e.addEventListener('click', () => {
                qtyInput.forEach(q => {
                    const valueQut = parseInt(q.value || '1') + 1;
                    q.value = valueQut
                    countProduct = valueQut
                })
                initDOMAction.domCalculTotal()
            });
        })

        btnDecrease.forEach(e => {
            e.addEventListener('click', () => {
                qtyInput.forEach(q => {
                    let current = parseInt(q.value || '1');
                    const valueQut = current - 1;
                    if (valueQut >= 1) {
                        q.value = valueQut
                        countProduct = valueQut
                    }
                })
                initDOMAction.domCalculTotal()
            });
        })
        /** INPUT QUT DIRECT */
        if (qtyInput?.length > 0) {
            qtyInput.forEach(input => {
                const handler = (e) => {
                    let v = e.target.value;

                    [...qtyInput].map(el => el.value = v)
                    countProduct = v || 1
                    initDOMAction.domCalculTotal()
                };
                input.addEventListener('input', handler);   // à chaque frappe
                input.addEventListener('change', handler);  // à la validation
            })
        }
        /*** STICKY */
        if (btnModeles.length > 0) {
            btnModeles.forEach((el) => {
                /**  */
                if (el.classList.contains('active')) {
                    variantSticky.innerText = el.dataset.title;
                }
                el.addEventListener('click', () => {
                    const variant = el.dataset.variant;
                    btnModeles.forEach((e) => {
                        if (e.dataset.variant == variant) {
                            e.classList.add('active');
                        } else {
                            e.classList.remove('active');
                        }
                    });
                    const price = el.dataset.price;
                    const title = el.dataset.title;
                    initDOMAction.domChangePrice(price)
                    variantSticky.innerText = title;
                });
            });
        }
    },
    domChangePrice: (price) => {
        priceCurrent = price;
        [...priceTag].forEach((e) => (e.innerText = price));

        initDOMAction.domCalculTotal()
    },
    domChangeDiscount: (price_compare, percent) => {
        if (price_compare) {

            [...priceDiscount].forEach(e => e.innerText = price_compare + "€");
            [...percentDiscount].forEach(e => e.innerText = "-" + percent + "%")
        } else {
            [...priceDiscount].forEach(e => e.innerText = "");
            [...percentDiscount].forEach(e => e.innerText = "")

        }

    },
    domScroller: () => {
        window.addEventListener('scroll', () => {
            const rect = btnCart.getBoundingClientRect();
            const isOutOfView = rect.bottom < 0 || rect.top > window.innerHeight;
            if (isOutOfView) {
                cartSticky.classList.add('is-visible');
            } else {
                cartSticky.classList.remove('is-visible');
            }
        });
    },
    domSelectVariantBundle: () => {
        /** LISTENER VARIANT BUBNDLE */
        const getDomVarian = document.querySelectorAll('.op-ivariant')
        if (getDomVarian.length > 0 && window.shopifyBundles) {

            getDomVarian.forEach(button => {

                button.addEventListener('click', (e) => {
                    const value = e.currentTarget.dataset.value;
                    const product = e.currentTarget.dataset.product;
                    const id = e.currentTarget.dataset.id;
                    const position = e.currentTarget.dataset.position;
                    const getDomPrice = [...priceBundle].find(e => e.dataset.id == id)
                    const matchBundle = shopifyBundles.find(bundles => bundles.id == id);
                    const titleBundles = document.querySelectorAll('.title-variant-bundle-active');
                    if (value && product && id && bundlesState[id] && titleBundles?.length > 0) {
                        /*** REMOVE OLD */
                        const getOnSameParent = document.querySelectorAll('.op-ivariant');
                        if (getOnSameParent.length > 0) {
                            const filterChildOption = [...getOnSameParent].filter(elm => elm.dataset.id == id && elm.dataset.product == product);
                            if (filterChildOption.length > 0) {
                                filterChildOption.map(e_child => e_child.classList.remove('active'))
                            }
                        }
                        bundlesState[id].options[parseInt(position)] = value;
                        const newBundleState = bundlesState[id].options;
                        const getMatchValue = matchBundle.variants.find(obj =>
                            Array.isArray(obj.options) &&
                            obj.options.length === newBundleState.length &&
                            obj.options.every((val, i) => val === newBundleState[i])
                        );
                        const matchTitle = titleBundles[position];
                        if (matchTitle) {
                            matchTitle.innerText = value
                        }
                        bundlesState[id].state = getMatchValue;
                        e.currentTarget.classList.add('active');
                        getDomPrice.innerText = (getMatchValue.price / 100).toFixed(2).replace('.', ',') + "€";
                    };
                });
            });
        }
    },
    domCalculTotal: () => {


        if (priceTotal?.length > 0 && priceCurrent) {
            priceTotal.forEach(e => {
                e.innerText = priceCurrent;
            })
        }
    },
    domBlundles: () => {
        if (window.shopifyBundles && shopifyBundles?.length > 0) {
            shopifyBundles.forEach(bundle => {
                const options = bundle.options;
                const variants = bundle.variants;
                const id = bundle.id;
                if (variants?.length > 0 && options?.length > 0) {
                    /**
                     * [ [val1,val2],[val3,val4] ]
                     */
                    const optionArrays = variants.map(item => item.options);
                    const transposed = optionArrays[0].map((_, i) =>
                        Array.from(new Set(optionArrays.map(arr => arr[i])))
                    );

                    /** GET BY ID */
                    const getDomVarian = [...allBundles].find(e => e.dataset.id == id);
                    const getDomPrice = [...priceBundle].find(e => e.dataset.id == id)
                    if (getDomVarian && getDomPrice) {
                        let html = ``;
                        options.forEach((e_opt, index) => {
                            const getValueOptionByIndex = transposed[index];

                            if (getValueOptionByIndex?.length > 0) {
                                html += `
                                    <div class="container-options-bundle">
                                        <p class="opt-title">${e_opt}</p>
                                        <div class="container-list-option">
                                            <button class="btn-open-list-bundle">
                                                <p data-id="${id}" class="variant-button-bundle title-variant-bundle-active active"  >${getValueOptionByIndex[0]}</p>
                                                <span class="icon-arrow-list"><img src="${themeAssets.arrow}" /></span>
                                            </button>
                                             <div class="list-option-variant">
                                        `;
                                getValueOptionByIndex.forEach((op, op_i) => {
                                    html += `<div class="option-item-variant">
                                        <button 
                                            class="op-ivariant variant-button-bundle  ${op_i == 0 ? 'active' : ''}" 
                                            data-product="${e_opt}" 
                                            data-position="${index}"
                                            data-value="${op}"
                                            data-id="${id}"
                                            >${op}</button>
                                        </div>
                                  
                                    `
                                })
                                html += `
                                        </div>
                                    </div>
                                </div>`;
                            }
                        })
                        getDomVarian.innerHTML = html;


                        /** FIRST */

                        const getFirstVariant = variants[0];
                        const formattedPrice = (getFirstVariant.price / 100).toFixed(2).replace('.', ',');
                        getDomPrice.innerText = formattedPrice + "€";

                        bundlesState[id] = {
                            options: [...getFirstVariant.options], // ← copie profonde des options
                            state: { ...variants[0], options: [...variants[0].options] } // ← copie propre
                        }
                    }
                }
            })
            initDOMAction.domSelectVariantBundle();
        }
    },
    activeLowerPrice: () => {
        const getAvailable = allVariants.filter(e => e.available);
        if (getAvailable?.length > 0) {
            let matchTour = false;
            getAvailable.forEach(variant_elm => {
                if (!matchTour) {
                    const title = variant_elm.title;
                    const options = variant_elm.options;
                    const price = variant_elm.price;
                    const priceDiscount = variant_elm.priceDiscount;
                    const percentDiscount = variant_elm.valueDiscount;
                    const newPrice = 0
                    const percent = 0;

                    let countOnGroup = 0;
                    for (const [optionKey, groups] of Object.entries(variantsByOption)) {
                        groups.forEach((g_elm, i_elm) => {
                            const matchByTitle = g_elm.variants.find(e => e.title == title);
                            if (matchByTitle) {
                                countOnGroup++;
                                variantsByOption[optionKey][i_elm].selected = true;
                            }
                        });
                    }
                    if (countOnGroup == options.length) {
                        matchTour = true;

                        if (priceDiscount) {
                            initDOMAction.domChangePrice(priceDiscount)
                            initDOMAction.domChangeDiscount(price, percentDiscount);
                        } else {
                            initDOMAction.domChangePrice(price)
                        }
                    }
                }
            });
            const minIndex = getAvailable.reduce((lowestIdx, item, idx, array) => {
                return item.priceFloat < array[lowestIdx].priceFloat ? idx : lowestIdx;
            }, 0);
            allVariants[minIndex].selected = true;
        }
    },
    normalize: (str) => {
        return str ? str.toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .replace(/[^a-z0-9]+/g, "_")
            .replace(/^_+|_+$/g, "") : '';
    },
    matchVariantsByTitle: (array1, array2) => {
        const matched = [];

        for (const v1 of array1) {
            const match = array2.find(v2 => v2.title === v1.title);
            if (match) {
                matched.push({ fromArray1: v1, fromArray2: match });
            }
        }

        return matched;
    },
    checkDiscountPrice: async () => {
        let collections = collectionDiscount;
        const handleProduct = handleProductCurrent; // produit courant (handle)

        try {
            /* collections = JSON.parse(collectionDiscount); */
        } catch (err) {
            console.error("❌ Error parsing collectionDiscount", err);
        }
        if (collections?.length > 0) {
            try {
                const res = await fetch(baseApiProduct + '/list-automatic-discounts?shop=' + shopNameProduct);
                const discounts = await res.json();
                if (discounts?.length > 0) {
                    const productCollectionIds = collections.map(c => c.id.toString());

                    let applicableDiscounts = [];

                    discounts.forEach(el => {
                        // --- Vérif collections ---
                        if (el.scope === "collections" && Array.isArray(el.collections) && el.collections.length > 0) {
                            const discountCollectionIds = el.collections.map(col =>
                                col.id.split("/").pop()
                            );
                            if (discountCollectionIds.some(id => productCollectionIds.includes(id))) {
                                applicableDiscounts.push(el);
                            }
                            /** UPSELL DISCOUNT COLLECTION */
                            if (upsellProduct?.length > 0) {
                                upsellProduct.forEach((e, i) => {
                                    if (e.collections?.length > 0 && discountCollectionIds.some(id => e.collections.find(ee => ee.id == id))) {
                                        const price_format = (e.price_lower / 100).toFixed(2)
                                        const discountedFloat = price_format - (price_format * el.value) / 100;
                                        upsellProduct[i].prieDiscountBrut = discountedFloat;
                                        upsellProduct[i].priceDiscount = initAppStandard.formatPrice(Math.ceil(discountedFloat * 100))
                                        upsellProduct[i].valueDiscount = el.value

                                    }
                                })
                            }
                        }

                        // --- Vérif produits ---
                        if (el.scope === "products" && Array.isArray(el.products) && el.products.length > 0) {
                            const discountProductHandles = el.products.map(p => p.handle);
                            if (discountProductHandles.includes(handleProduct)) {
                                applicableDiscounts.push(el);
                            }
                            /** UPSELL DISCOUNT PRODUCT */
                            if (upsellProduct?.length > 0) {
                                upsellProduct.forEach((e, i) => {
                                    if (discountProductHandles.includes(e.handle)) {
                                        const price_format = (e.price_lower / 100).toFixed(2)
                                        const discountedFloat = price_format - (price_format * el.value) / 100;
                                        if (e.prieDiscountBrut && e.prieDiscountBrut > discountedFloat) {
                                            upsellProduct[i].prieDiscountBrut = discountedFloat;
                                            upsellProduct[i].priceDiscount = initAppStandard.formatPrice(Math.ceil(discountedFloat * 100))
                                            upsellProduct[i].valueDiscount = el.value
                                        }
                                    }
                                })
                            }
                        }
                    });

                    if (applicableDiscounts.length > 0) {
                        // prendre le discount avec la plus grande value
                        const bestDiscount = applicableDiscounts.reduce((max, current) =>
                            current.value > max.value ? current : max
                        );

                        const bestValue = bestDiscount.value;


                        /*** APPLY ON getShopifyOptions ***/
                        if (typeof getShopifyOptions === "object" && getShopifyOptions !== null) {
                            Object.keys(getShopifyOptions).forEach(optionKey => {
                                getShopifyOptions[optionKey] = getShopifyOptions[optionKey].map(opt => {
                                    return {
                                        ...opt,
                                        variants: opt.variants.map(variant => {
                                            if (
                                                variant &&
                                                typeof variant.priceFloat === "number" &&
                                                !isNaN(variant.priceFloat)
                                            ) {
                                                const discountedFloat = variant.priceFloat - (variant.priceFloat * bestValue) / 100;
                                                return {
                                                    ...variant,
                                                    valueDiscount: bestValue,
                                                    priceDiscount: initAppStandard.formatPrice(Math.ceil(discountedFloat * 100))
                                                };
                                            }
                                            return variant;
                                        })
                                    };
                                });
                            });

                        }

                        /*** APPLY ON getShopifyMultiOptions ***/
                        if (typeof getShopifyMultiOptions === "object" && getShopifyMultiOptions !== null) {
                            Object.keys(getShopifyMultiOptions).forEach(optionKey => {
                                getShopifyMultiOptions[optionKey] = getShopifyMultiOptions[optionKey].map(opt => {
                                    return {
                                        ...opt,
                                        variants: opt.variants.map(variant => {
                                            if (
                                                variant &&
                                                typeof variant.priceFloat === "number" &&
                                                !isNaN(variant.priceFloat)
                                            ) {
                                                const discountedFloat = variant.priceFloat - (variant.priceFloat * bestValue) / 100;
                                                return {
                                                    ...variant,
                                                    valueDiscount: bestValue,
                                                    priceDiscount: initAppStandard.formatPrice(Math.ceil(discountedFloat * 100))
                                                };
                                            }
                                            return variant;
                                        })
                                    };
                                });
                            });

                        }

                    }

                }
            } catch (err) {
                console.error("❌ Error fetching discounts", err);
            }
        }

        if (lazyLoader?.length > 0) {
            [...lazyLoader].forEach(e => e.classList.add('disable'))
        }
    },
    domVariants: async () => {
        async function withTimeout(promise, ms) {
            return Promise.race([
                promise,
                new Promise(resolve => setTimeout(resolve, ms))
            ]);
        }

        // ✅ attend checkDiscountPrice max 3s
        await withTimeout(initDOMAction.checkDiscountPrice(), secondeWaitDiscount);

        function addOptionData(source) {
            for (const [rawOptionName, optionGroups] of Object.entries(source || {})) {
                const optionName = initDOMAction.normalize(rawOptionName);

                if (!variantsByOption[optionName]) {
                    variantsByOption[optionName] = [];
                }

                for (const group of optionGroups) {
                    const label = initDOMAction.normalize(group.label);
                    const existingGroup = variantsByOption[optionName].find(
                        g => initDOMAction.normalize(g.label) === label
                    );

                    if (!existingGroup) {
                        const sortedVariants = [...group.variants].sort(
                            (a, b) => parseFloat(a.priceFloat) - parseFloat(b.priceFloat)
                        );

                        variantsByOption[optionName].push({
                            label: group.label,
                            min_price: parseFloat(sortedVariants[0].price),
                            active: sortedVariants.some(v => v.available),
                            variants: sortedVariants,
                            selected: false
                        });
                    } else {
                        const existingIds = new Set(existingGroup.variants.map(v => v.id));
                        for (const variant of group.variants) {
                            if (!existingIds.has(variant.id)) {
                                existingGroup.variants.push({ ...variant });
                            }
                        }

                        existingGroup.variants.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
                        existingGroup.min_price = parseFloat(existingGroup.variants[0].price);
                        existingGroup.active = existingGroup.variants.some(v => v.available);
                    }
                }

                // 🔽 Trier les groupes par min_price
                variantsByOption[optionName].sort((a, b) => a.min_price - b.min_price);
                if (variantsByOption[optionName]?.length > 0) {
                    variantsByOption[optionName].forEach(el => {
                        el.variants.forEach(e => {
                            if (allVariants.length > 0) {
                                const isAlreadyOn = allVariants.find(a => a.title == e.title);
                                if (!isAlreadyOn) {
                                    allVariants.push(e);
                                }
                            } else {
                                allVariants.push(e);
                            }
                        })
                    })
                }
            }
            if (allVariants?.length > 0) {
                allVariants.sort((a, b) => a.priceFloat - b.priceFloat);
            }
        }
        console.log("getShopifyMultiOptions", getShopifyMultiOptions);

        addOptionData(getShopifyOptions);
        addOptionData(getShopifyMultiOptions);
        initDOMAction.activeLowerPrice();

        /*** BTN VARIANT TOP */
        initDOMAction.domBtnVariantTop();
        initDOMAction.domBtnVariantBottom();
        initDOMAction.domStickyAction();
        initDOMAction.domUpSell();
    },
    domUpSell: () => {
        if (upsellProduct?.length > 0) {
            if (upsellProduct.length == 0) {
                listUpsell.innerHTML = ``;
            }
            let html = ``;
            const getBackImg = listUpsell.dataset.backimg
            upsellProduct.forEach((product) => {
                html += ` 
          <div class="card-product-upsell">
            <a class="link-upsell" href="${product.url}" style="background-image: url(${getBackImg});">
                <div class="img-container-upsell">
                      
                        <img
                         class="img-product-upsell" 
                         src="${product.image_grey}" 
                         alt="${product.title}"
                         >
                      
                    </div>
  
                <div class="img-shadow-img"> 
                  <img
                    class="img-ombre"
                    src="${product.image_ombre}"
                    alt="ombre"
                  >
                </div>   
            </a>
            <div class="info-upsell">
              <h3>${product.title}</h3>
              <div class="card-bottom">
              
                <div>
                    <p class="text-light price-start">À partir de</p>
                    <p class="text-bold price-card white price-banner-product target-price-discount ">
                        ${product.priceDiscount ? product.priceDiscount : product.price_original}
                        ${product.priceDiscount ? (
                        `
                          <span class="old-price-container">
                              <em class="old-price">${product.price_original}</em>
                              <em class="percent-discount-change">-${product.valueDiscount}%</em>
                          </span>
                          `
                    ) : ""}
                    </p>
                </div>
                <p class="btn-tag-price">Acheter</p>
              </div>
            </div>
          </div>`;
            });
            listUpsell.innerHTML = html;
        }
    },
    domBtnVariantTop: () => {
        if (idProductVariant && Object.keys(variantsByOption)?.length > 0) {
            let html = '';
            console.log(variantsByOption, "variantsByOption")
            for (const [optionKey, groups] of Object.entries(variantsByOption)) {
                if (groups?.length > 1) {
                    // Remet un nom affichable : remplace _ par espace + capitalisation
                    const displayName = optionKey.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());

                    html += `<div class="variant-group">`;
                    html += `
                         <div class="container-list-option">
                            <p class="variant-group-title"  >${displayName}</p>
                            <div  class="list-option-variants-next">
                    `;

                    for (const group of groups.slice(0, limitShowOptionList)) {
                        html += `
                            <button 
                            class="variant-btn variant-top-target variant-selectable ${group.selected ? "active" : ""} ${group.active ? "" : "not-available"} " 
                            data-display="${optionKey}"
                            data-variant-id="${group.variants[0].id}" 
                            data-label="${group.label}">
                            ${group.label}
                            </button>
                        `;
                    }
                    for (const group of groups.slice(limitShowOptionList)) {
                        html += ` <button 
                            class="variant-btn variant-selectable hide-variant-selectable ${group.selected ? "active" : ""} ${group.active ? "" : "not-available"} " 
                            data-display="${optionKey}"
                            data-variant-id="${group.variants[0].id}" 
                            data-label="${group.label}">
                            ${group.label}
                            </button>`
                    }
                    /** BUTTON MORE */
                    if (groups.length > limitShowOptionList) {
                        html += `
                        <button 
                            data-display="${optionKey}"
                            class="variant-btn more-list-variant " 
                         ">
                            +${groups.length - limitShowOptionList}
                            </button>
                        `
                    }
                    html += `
                        </div>
                    </div>`;
                }
            }

            idProductVariant.innerHTML = html;

            // Events
            const allVariantsOption = document.querySelectorAll(".variant-top-target")
            allVariantsOption.forEach(btn => {
                btn.addEventListener("click", (e) => {
                    initDOMAction.domSelectedOption(btn)
                });
            });

            const btnMore = document.querySelectorAll('.more-list-variant');
            const variants = document.querySelectorAll('.hide-variant-selectable');
            if (btnMore.length > 0 && variants.length > 0) {
                btnMore.forEach(btn => {
                    btn.addEventListener('click', () => {
                        const displayTarget = btn.dataset.display;
                        if (displayTarget) {
                            const getEveryHide = [...variants].filter(btnHide => btnHide.dataset.display == displayTarget);
                            if (getEveryHide?.length > 0) {
                                getEveryHide.forEach(btnHide => {
                                    btnHide.classList.toggle('hide-variant-selectable');
                                });
                            }
                        }
                    })
                });
            }
        }
    },
    domStickyAction: () => {
        if (stickyTarget && containerPaiement) {


            window.addEventListener("scroll", () => {
                if (containerPaiement.getBoundingClientRect().top < 0) {
                    stickyTarget.classList.add('active')
                } else {
                    stickyTarget.classList.remove('active')
                }
            });
        }

    },
    domBtnVariantBottom: () => {
        if (idProductVariantSticky && Object.keys(variantsByOption)?.length > 0) {
            let html = '';

            for (const [optionKey, groups] of Object.entries(variantsByOption)) {
                // Remet un nom affichable : remplace _ par espace + capitalisation
                const displayName = optionKey.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                const getActive = groups.find(e => e.active);


                if (getActive) {
                    html += `
                        <div class="sticky-variants container-options-bundle">
                            <p class="opt-title">${displayName}</p>
                            <div class="container-list-option">
                                <button class="btn-open-list-bundle">
                                    <p data-display="${optionKey}" class="variant-button-bundle variant-title-sticky active"  >${getActive.label}</p>
                                    <span class="icon-arrow-list"><img src="${themeAssets.arrow}" /></span>
                                </button>
                                    <div class="list-option-variant">
                            `;
                    groups.forEach((group) => {
                        html += `<div class="option-item-variant">
                             <button 
                                class="op-ivariant variant-sticky-target variant-selectable variant-button-bundle ${group.selected ? "active" : ""} ${group.active ? "" : "not-available"} " 
                                data-display="${optionKey}"
                                data-variant-id="${group.variants[0].id}" 
                                data-label="${group.label}">
                                ${group.label}
                                </button>
                            </div>
                        `
                    })
                    html += `
                            </div>
                        </div>
                    </div>`;
                }
            }

            idProductVariantSticky.innerHTML = html;
            // Events
            const allVariantsOption = document.querySelectorAll(".variant-sticky-target")
            allVariantsOption.forEach(btn => {
                btn.addEventListener("click", (e) => {
                    initDOMAction.domSelectedOption(btn)
                });
            });
        }
    },
    getDiscountPercent: (price, compareAtPrice) => {
        if (!price || !compareAtPrice || compareAtPrice <= price) {
            return 0; // pas de promo
        }
        return Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
    },
    domSelectedOption: (btn) => {
        const allVariantsOption = document.querySelectorAll(".variant-selectable")
        const allTitleSticky = document.querySelectorAll('.variant-title-sticky');
        const label = btn.dataset.label;
        const display = btn.dataset.display;
        const match = variantsByOption[display].find(e => e.label == label)
        const matchIndex = variantsByOption[display].findIndex(e => e.label == label)
        const otherVariant = Object.entries(variantsByOption)
            .filter(([key]) => key !== display)
            .reduce((obj, [key, value]) => {
                obj[key] = value;
                return obj;
            }, {});
        /** CHANGE ON SAME VARIANTS */
        variantsByOption[display].forEach(e => { e.selected = false });
        variantsByOption[display][matchIndex].selected = true;

        /** CHECK OTHER LIST */
        if (match?.active && match.variants.length > 0 && otherVariant && Object.keys(otherVariant).length > 0) {
            const variants_list = match.variants;
            if (variants_list?.length > 0) {
                /** MOVE SELECTED AND ACTIVE */
                for (const [optionKey, groups] of Object.entries(otherVariant)) {
                    groups.forEach((group_elm, group_elm_index) => {
                        const variants = group_elm.variants;
                        /** MATCH LINE */
                        const initMatch = initDOMAction.matchVariantsByTitle(variants, variants_list)
                        if (initMatch?.length == 0) {
                            variantsByOption[optionKey][group_elm_index].selected = false;
                            variantsByOption[optionKey][group_elm_index].active = false;
                        } else {
                            variantsByOption[optionKey][group_elm_index].active = true;
                        }
                    });
                }
                /** CHECK AND ADD */
                let select_stop = false;
                for (const [optionKey, groups] of Object.entries(otherVariant)) {
                    const isNoSelected = groups.filter(e => e.selected);
                    if (isNoSelected.length == 0) {

                        groups.forEach((group_elm, group_elm_index) => {
                            const variants = group_elm.variants;
                            const initMatch = initDOMAction.matchVariantsByTitle(variants, variants_list)
                            if (initMatch?.length > 0 && !select_stop) {
                                select_stop = true
                                variantsByOption[optionKey][group_elm_index].selected = true;
                                variantsByOption[optionKey][group_elm_index].active = true;
                            } else {

                            }

                        });
                    }
                }

            }
        }

        /** CHNAGE PRICE */
        let reconstructSelect = [];
        Object.keys(variantsByOption).map(key => {
            /** ACTIVE CURRENT */
            const getCurrent = variantsByOption[key].find(elm => elm.active && elm.selected);
            if (getCurrent && getCurrent?.label) {
                reconstructSelect.push(getCurrent.label);
                /*** DOM */
                [...allVariantsOption].filter(var_elm => var_elm.dataset.display == key).forEach(other_elm => {
                    if (other_elm.dataset.label == getCurrent.label) {
                        const matchStickyTitle = allTitleSticky?.length > 0 && [...allTitleSticky].find(st_el => st_el.dataset.display == key);
                        if (matchStickyTitle) {
                            matchStickyTitle.innerText = getCurrent.label;
                        }
                        other_elm.classList.add('active')
                    } else {
                        other_elm.classList.remove('active')
                    }
                });

            }
            /**  */
            const group_variant = variantsByOption[key];
            group_variant.forEach(elm_group => {
                const matchDOMoption = [...allVariantsOption].filter(el_dom => el_dom.dataset.label == elm_group.label);


                if (matchDOMoption?.length > 0) {

                    if (elm_group.active) {
                        [...matchDOMoption].map(e => e.classList.remove('not-available'))

                    } else {
                        [...matchDOMoption].map(e => e.classList.add('not-available'))

                    }
                }
            });

        });

        if (reconstructSelect.length > 0) {
            const indexMatchVariant = allVariants.findIndex(e => JSON.stringify(e.options) == JSON.stringify(reconstructSelect));
            const matchVariantLine = allVariants[indexMatchVariant];
            allVariants.forEach(e => e.selected = false)
            allVariants[indexMatchVariant].selected = true;
            if (matchVariantLine) {
                const discountElm = matchVariantLine.priceDiscount;
                const percentElm = matchVariantLine.valueDiscount;
                if (discountElm) {
                    initDOMAction.domChangePrice(discountElm)
                    initDOMAction.domChangeDiscount(matchVariantLine.price, percentElm)
                } else {
                    initDOMAction.domChangePrice(matchVariantLine.price)
                    initDOMAction.domChangeDiscount(matchVariantLine.priceCompare, initDOMAction.getDiscountPercent(matchVariantLine.priceFloat, matchVariantLine.pirceFloatCompare))
                }
            } else {
                /** NO MATCH */
            }
        }
    },
    domAddCart: () => {
        if (btnCallCart) {
            btnCallCart.forEach(e => {
                e.addEventListener('click', async () => {
                    const getSelected = allVariants.find(e => e.selected);
                    if (getSelected) {
                        const idVariant = getSelected.id;
                        initDOMAction.domAddProduct(idVariant)
                    } else {

                    }
                })
            })
        }
    },
    domAddCartBundle: () => {
        if (btnCallCartBundle?.length > 0) {
            btnCallCartBundle.forEach(el => {
                el.addEventListener('click', () => {
                    const id = el.dataset.id;
                    const matchBundle = bundlesState.hasOwnProperty(id) ? bundlesState[id] : null
                    if (matchBundle?.state) {

                        const idVariant = matchBundle.state.id

                        if (idVariant) {
                            initDOMAction.domAddProduct(idVariant)
                        }
                    }
                })
            })
        }
    },
    toogleLoader: (b) => {
        if (btnCallCart?.length > 0) {
            [...btnCallCart].forEach(em => {
                if (b) {
                    em.classList.add('active')
                } else {
                    em.classList.remove('active')
                }
            });


        }
    },
    domAddProduct: async (idVariant) => {
        initDOMAction.toogleLoader(true)
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            body: new URLSearchParams({
                id: idVariant, // ID de variante
                quantity: countProduct
            })
        }).then(r => r.json());
        initDOMAction.toogleLoader(false)
        /** UPSELL MODAL */
        if (overlaySuccess && modalSuccessAdd) {
            initAppStandard.cart();
            /** LOTTIE */
            lottie.loadAnimation({
                container: lottieContainer,
                renderer: 'svg',
                loop: false,
                autoplay: true,
                path: themeAssets.success
            });
            setTimeout(() => {
                lottie.loadAnimation({
                    container: targetCloseSuccess,
                    renderer: 'svg',
                    loop: false,
                    autoplay: true,
                    path: themeAssets.close
                });
            }, 1500);
            initDOMAction.domLockBody(true)
            modalSuccessAdd.classList.add('active');
            overlaySuccess.classList.add('active-black-desk')
        }
    },
    domReadMore: () => {
        if (btnReadMore) {
            btnReadMore.addEventListener('click', () => {
                btnReadMore.innerText = textReadDesc.classList.contains('expanded') ? "Lire la suite" : "Réduire";

                textReadDesc.classList.toggle('expanded')
            })
        }

    },
    domCloseSuccess: () => {
        overlaySuccess.classList.remove('active-black-desk')
        modalSuccessAdd.classList.remove('active')
        modalSuccessNext.classList.remove('active')
        lottieContainer.innerHTML = ''
        targetCloseSuccess.innerHTML = ''
        initDOMAction.domLockBody(false)
    },
    domLockBody: (b) => {
        if (b) {
            document.querySelector('body').style.overflowY = "hidden"
        } else {
            document.querySelector('body').style.overflowY = 'scroll'
        }
    },
    domOpenCart: () => {
        if (overlaySuccess && targetCartPageProduct) {
            overlaySuccess.classList.add('active-black-desk')
            targetCartPageProduct.classList.add('active')
        }
    },
    domFx: () => {
        if (animBlockBanner) {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            animBlockBanner.classList.add('active');

                        } else {
                            animBlockBanner.classList.remove('active');

                        }
                    });
                },
                { threshold: 0.4 } // déclenche quand 10% de l'élément est visible
            );

            observer.observe(animBlockBanner);
        }
        if (listDescProduct.length > 0) {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('active-fx');
                        } else {
                            entry.target.classList.remove('active-fx');
                        }
                    });
                },
                { threshold: 0.4 } // tu peux ajuster selon le besoin
            );

            listDescProduct.forEach(el => observer.observe(el));
        }
        if (blockImgLong) {

            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            blockImgLong.classList.add('active');

                        } else {
                            blockImgLong.classList.remove('active');

                        }
                    });
                },
                { threshold: 0.2 } // déclenche quand 10% de l'élément est visible
            );

            observer.observe(blockImgLong);
        }
        if (allTitleOdd?.length > 0) {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('active');
                        } else {
                            entry.target.classList.remove('active');
                        }
                    });
                },
                { threshold: 0.4 } // tu peux ajuster selon le besoin
            );

            allTitleOdd.forEach(el => observer.observe(el));
        }
        if (allImgOdd?.length > 0) {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            entry.target.classList.add('active');
                        } else {
                            entry.target.classList.remove('active');
                        }
                    });
                },
                { threshold: 0.4 } // tu peux ajuster selon le besoin
            );

            allImgOdd.forEach(el => observer.observe(el));
        }

        if (overlaySuccess && modalSuccessAdd) {
            overlaySuccess.addEventListener('click', () => {
                initDOMAction.domCloseSuccess()
            })
        }
        if (targetCloseSuccess && modalSuccessAdd) {
            targetCloseSuccess.addEventListener('click', () => {
                initDOMAction.domCloseSuccess()
            })
        }
        if (btnSuccessCart) {
            btnSuccessCart.addEventListener('click', () => {
                if (upsellProduct?.length > 0) {
                    stateNextSuccess = "cart";
                    modalSuccessNext.classList.add('active')
                } else {
                    initDOMAction.domCloseSuccess()
                    initDOMAction.domOpenCart();
                }
            })
        }
        if (btnSuccessBuy) {
            btnSuccessBuy.addEventListener('click', () => {
                if (upsellProduct?.length > 0) {
                    stateNextSuccess = "buy";
                    modalSuccessNext.classList.add('active')
                } else {
                    initDOMAction.domCloseSuccess()
                }
            })
        }
        if (btnNextSuccess) {
            btnNextSuccess.addEventListener('click', () => {
                initDOMAction.domCloseSuccess()
                if (stateNextSuccess == "cart") {
                    initDOMAction.domOpenCart()
                }
                stateNextSuccess = ""
            })
        }
    },
    init: () => {
        initDOMAction.domFx();
        initDOMAction.domVariants();
        initDOMAction.domScroller();
        initDOMAction.submitBuyProduct();
        initDOMAction.domCaracteristique();
        initDOMAction.domSwitchModels()
        initDOMAction.domBlundles();
        initDOMAction.domReadMore();
        initDOMAction.domAddCart();
        initDOMAction.domAddCartBundle();
    }
}

document.addEventListener('DOMContentLoaded', function () {
    initDOMAction.init();
});